var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex flex-row w-full h-full" };
const _hoisted_2 = {
    style: { "width": "936px" },
    class: "h-full bg-gray-100 flex flex-col space-y-4 relative"
};
const _hoisted_3 = {
    ref: "tuiImageEditor",
    class: "flex flex-col items-center justify-center w-full relative",
    style: { "height": "480px" }
};
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { id: "ghl-image-editor-container" }, null, -1);
const _hoisted_5 = [
    _hoisted_4
];
import ModalHeader from '@/components/options/ModalHeaderV2.vue';
import { dataURLtoBlob } from '@/compositions/useDataUrlToBlob';
import { useImageSize } from '@/compositions/useImageSize';
import { getFilterValues, setFilterValues, } from '@/compositions/useKonvaFilterValues';
import { MediaService } from '@/services/MediaService';
import { Tools } from '@/types/tools';
import { UIModal, UIModalContent, UIModalFooter, UIModalHeader, UISpin, } from '@gohighlevel/ghl-ui';
import Konva from 'konva';
import { computed, onMounted, onUnmounted, ref, watch } from 'vue';
import Options from './options/ImageOptions.vue';
import CropSubTool from './options/tools/CropSubTool.vue';
import { getHistoryObject } from '@/compositions/useHistoryHelper';
import { useHistoryStore } from '@/store/history';
import { HistoryType } from '@/types/history';
import ConfirmationModal from './modals/ConfirmationModal';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ImageEditor',
    props: {
        imageUrl: {
            type: String,
            require: true,
        },
        imageName: {
            type: String,
            require: true,
        },
        locationId: {
            type: String,
            require: true,
        },
    },
    emits: ['close', 'done'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const historyStore = useHistoryStore();
        let stage, layer, group, scaleFactor;
        const cropperImage = ref('');
        const showModal = ref(true);
        const containerWidth = ref(600);
        const containerHeight = ref(400);
        const baseImageWidth = ref();
        const baseImageHeight = ref();
        const showLoader = ref(true);
        const saveLoader = ref(false);
        const imageSize = ref();
        const resetInprogress = ref(false);
        const selectedOption = ref(Tools.CROP);
        const baseImage = ref();
        const adjustmentChanges = ref(false);
        const filterChanges = ref(false);
        const cropChanges = ref(false);
        const sectionReset = ref(false);
        const beforeObject = ref({});
        const afterObject = ref({});
        const showConfirmation = ref(false);
        const imageSrc = computed(() => props.imageUrl);
        const isLoading = computed(() => showLoader.value);
        onMounted(() => {
            cropperImage.value = imageSrc.value;
            if (props.imageUrl) {
                startEditor();
            }
        });
        onUnmounted(() => {
            try {
                stage.removeChildren();
                stage.destroy();
                historyStore.reset();
            }
            catch (error) {
                // console.log('Error with cropper destroy')
            }
        });
        watch(imageSrc, () => {
            if (imageSrc.value) {
                cropperImage.value = imageSrc.value;
                startEditor();
            }
        });
        function startEditor() {
            return __awaiter(this, void 0, void 0, function* () {
                if (stage)
                    return;
                stage = new Konva.Stage({
                    container: 'ghl-image-editor-container',
                    width: containerWidth.value,
                    height: containerHeight.value,
                });
                initializeEditor();
                const { size } = yield useImageSize(imageSrc.value);
                imageSize.value = size;
            });
        }
        function initializeEditor() {
            layer = new Konva.Layer();
            stage.add(layer);
            loadImage(props.imageUrl);
        }
        function createGroup() {
            group = new Konva.Group({
                x: 0,
                y: 0,
                width: stage.width(),
                height: stage.height(),
            });
        }
        function loadImage(dataUrl, reload, filters) {
            try {
                showLoader.value = true;
                const image = new Image();
                image.onload = () => {
                    createGroup();
                    const stageWidth = stage.width();
                    const stageHeight = stage.height();
                    const imageWidth = image.width;
                    const imageHeight = image.height;
                    baseImageWidth.value = imageWidth;
                    baseImageHeight.value = imageHeight;
                    // Calculate the scaling factors to fit the image within the canvas
                    const scaleX = stageWidth / imageWidth;
                    const scaleY = stageHeight / imageHeight;
                    // Determine the appropriate scale factor to fit the image within the canvas
                    scaleFactor = Math.min(scaleX, scaleY);
                    // New with and height for image
                    const newImageWidth = Math.floor(imageWidth * scaleFactor);
                    const newImageHeight = Math.floor(imageHeight * scaleFactor);
                    if (!reload) {
                        stage.width(newImageWidth);
                        stage.height(newImageHeight);
                    }
                    const left = Math.floor(stage.width() / 2) - Math.floor(newImageWidth / 2);
                    const top = Math.floor(stage.height() / 2) - Math.floor(newImageHeight / 2);
                    baseImage.value = new Konva.Image({
                        x: left,
                        y: top,
                        image: image,
                        width: newImageWidth,
                        height: newImageHeight,
                        align: 'center',
                        id: 'ghl-image-editor-base-image',
                        rotation: 0,
                    });
                    baseImage.value.cache();
                    if (filters) {
                        baseImage.value.filters(filters.filters);
                        setFilterValues(baseImage.value, filters.values);
                    }
                    group.add(baseImage.value);
                    // Add the Konva image to your layer
                    layer.add(group);
                    stage.batchDraw();
                    setTimeout(() => {
                        stage.getContainer().style.backgroundColor = 'black';
                        showLoader.value = false;
                    }, 500);
                };
                image.crossOrigin = 'Anonymous';
                image.src = dataUrl;
            }
            catch (error) {
                showLoader.value = false;
                // console.log('error')
            }
        }
        function downloadImage(quality) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (saveLoader.value)
                        return;
                    saveLoader.value = true;
                    showLoader.value = true;
                    setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                        if (imageSize.value > 2000000)
                            quality = 0.7;
                        let blob = getImageBlob(quality, scaleFactor);
                        let isStart = true;
                        while (isStart) {
                            if (blob.size > 8000000) {
                                blob = getImageBlob(quality - 0.1, 1);
                            }
                            else {
                                isStart = false;
                                yield uploadImage(blob);
                                saveLoader.value = false;
                                showLoader.value = false;
                            }
                        }
                    }), 300);
                }
                catch (error) {
                    // Handle Error
                    saveLoader.value = false;
                    showLoader.value = false;
                }
            });
        }
        function getImageBlob(quality, scale) {
            const filters = baseImage.value.filters();
            const filterValues = getFilterValues(baseImage.value, filters);
            baseImage.value.clearCache();
            baseImage.value.setAttrs({
                x: baseImage.value.x() / scale,
                y: baseImage.value.y() / scale,
                width: baseImage.value.width() / scale,
                height: baseImage.value.height() / scale,
            });
            baseImage.value.cache();
            baseImage.value.filters(filters);
            setFilterValues(baseImage.value, filterValues);
            const downloadImageData = baseImage.value.toDataURL({
                mimeType: 'image/jpeg',
                imageSmoothingEnabled: false,
                quality,
            });
            const blob = dataURLtoBlob(downloadImageData);
            return blob;
        }
        function closeEditor() {
            if (historyStore.history.length) {
                showConfirmation.value = true;
            }
            else {
                emits('close');
            }
        }
        function uploadImage(imageData) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const imageName = `${props.imageName.split('.')[0]}.jpeg`;
                    const { data } = yield MediaService.initializeUpload({
                        altId: props.locationId,
                        altType: 'location',
                        name: imageName,
                        size: imageData.size,
                        contentType: 'image/jpeg',
                        parentId: '',
                    });
                    if (data.aknId && data.url) {
                        yield MediaService.uploadBlob(data.url, imageData);
                        const completedMedia = yield MediaService.finalizeUpload({
                            altId: props.locationId,
                            altType: 'location',
                            id: data.aknId,
                        });
                        if (completedMedia.data && completedMedia.data.url) {
                            emits('done', completedMedia.data.url);
                        }
                    }
                }
                catch (error) {
                    // error to handle error message
                }
            });
        }
        function appliedChanges(type) {
            switch (type) {
                case Tools.CROP:
                    if (showLoader.value)
                        return;
                    showLoader.value = true;
                    setTimeout(() => applyCroppedImage(), 100);
                    break;
            }
        }
        function resetChanges(type) {
            switch (type) {
                case Tools.CROP:
                    resetImage();
                    break;
                case Tools.ADJUSTMENTS:
                    adjustmentChanges.value = false;
                    setSectionReset();
                    break;
                case Tools.FILTERS:
                    filterChanges.value = false;
                    setSectionReset();
                    break;
            }
        }
        function setSectionReset() {
            sectionReset.value = true;
            setTimeout(() => {
                sectionReset.value = false;
            }, 300);
        }
        function setCroppingOverImage() {
            const cropBoxTransform = stage.find('#ghl-image-editor-crop-box-transformer')[0];
            const cropBox = stage.find('#ghl-image-editor-crop-box')[0];
            if (cropBoxTransform && cropBox) {
                group.setAttrs({
                    clipX: cropBoxTransform.x(),
                    clipY: cropBoxTransform.y(),
                    clipWidth: cropBoxTransform.width(),
                    clipHeight: cropBoxTransform.height(),
                });
                cropBoxTransform.detach();
                cropBoxTransform.destroy();
                cropBox.destroy();
                stage.batchDraw();
            }
        }
        function applyCroppedImage() {
            setCroppingOverImage();
            let filters = baseImage.value.filters();
            if (!filters)
                filters = [];
            const filterValues = getFilterValues(baseImage.value, filters);
            baseImage.value.clearCache();
            baseImage.value.setAttrs({
                x: baseImage.value.x() / scaleFactor,
                y: baseImage.value.y() / scaleFactor,
                width: baseImage.value.width() / scaleFactor,
                height: baseImage.value.height() / scaleFactor,
            });
            beforeObject.value = getHistoryObject(selectedOption.value, baseImage.value, HistoryType.REPLACE);
            group.setAttrs({
                x: group.x() / scaleFactor,
                y: group.y() / scaleFactor,
                clipX: group.clipX() / scaleFactor,
                clipY: group.clipY() / scaleFactor,
                clipWidth: group.clipWidth() / scaleFactor,
                clipHeight: group.clipHeight() / scaleFactor,
            });
            const imageData = group.toDataURL({
                mimeType: 'image/jpeg',
                x: group.clipX(),
                y: group.clipY(),
                width: group.clipWidth(),
                height: group.clipHeight(),
                imageSmoothingEnabled: false,
            });
            afterObject.value = getHistoryObject(selectedOption.value, baseImage.value, HistoryType.REPLACE, { blob: imageData });
            baseImage.value.destroy();
            group.destroy();
            stage.batchDraw();
            loadImage(imageData, true, { filters, values: filterValues });
            cropChanges.value = true;
            setHistory(HistoryType.REPLACE);
        }
        function resetImage() {
            let filters = baseImage.value.filters();
            if (!filters)
                filters = [];
            const filterValues = getFilterValues(baseImage.value, filters);
            baseImage.value.clearCache();
            baseImage.value.destroy();
            group.destroy();
            stage.batchDraw();
            loadImage(imageSrc.value, false, { filters, values: filterValues });
            cropChanges.value = false;
        }
        function setActiveTool(val) {
            selectedOption.value = val;
        }
        function setUpdate(type) {
            switch (type) {
                case Tools.ADJUSTMENTS:
                    adjustmentChanges.value = true;
                    break;
                case Tools.FILTERS:
                    filterChanges.value = true;
                    break;
            }
        }
        function setHistory(type) {
            const id = baseImage.value.getId();
            historyStore.setHistory(id, selectedOption.value, beforeObject.value, afterObject.value, type);
        }
        function setHistoryImage(blob) {
            const cropBoxTransform = stage.find('#ghl-image-editor-crop-box-transformer')[0];
            const cropBox = stage.find('#ghl-image-editor-crop-box')[0];
            let filters = baseImage.value.filters();
            if (!filters)
                filters = [];
            const filterValues = getFilterValues(baseImage.value, filters);
            if (cropBoxTransform && cropBox) {
                cropBoxTransform.detach();
                cropBoxTransform.destroy();
                cropBox.destroy();
            }
            baseImage.value.clearCache();
            baseImage.value.destroy();
            group.destroy();
            stage.batchDraw();
            loadImage(blob, true, { filters, values: filterValues });
        }
        function continueEditing() {
            showConfirmation.value = false;
        }
        function close() {
            emits('close');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(_unref(UIModal), {
                    show: showModal.value,
                    "onUpdate:show": _cache[1] || (_cache[1] = ($event) => ((showModal).value = $event)),
                    width: 1200
                }, {
                    header: _withCtx(() => [
                        _createVNode(_unref(UIModalHeader), {
                            type: "custom",
                            id: "ghl-image-editor-modal-header",
                            class: "border-b border-gray-200 pb-3"
                        }, {
                            customHeader: _withCtx(() => [
                                _createVNode(ModalHeader, {
                                    loading: _unref(isLoading),
                                    stage: _unref(stage),
                                    "disable-action": showConfirmation.value,
                                    onClose: closeEditor,
                                    onLoadImage: setHistoryImage
                                }, null, 8, ["loading", "stage", "disable-action"])
                            ]),
                            _: 1
                        })
                    ]),
                    footer: _withCtx(() => [
                        _createVNode(_unref(UIModalFooter), {
                            loading: saveLoader.value,
                            negativeText: _ctx.$t('common.cancel'),
                            positiveText: _ctx.$t('common.save'),
                            type: "primary",
                            onNegativeClick: closeEditor,
                            onPositiveClick: _cache[0] || (_cache[0] = ($event) => (downloadImage(0.8))),
                            id: "image-editor-footer",
                            class: "border-t border-gray-200 pt-3 mt-0"
                        }, null, 8, ["loading", "negativeText", "positiveText"])
                    ]),
                    default: _withCtx(() => [
                        _createVNode(_unref(UIModalContent), {
                            class: "flex flex-row",
                            style: { "height": "550px" }
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, [
                                    _createVNode(Options, {
                                        stage: _unref(stage),
                                        group: _unref(group),
                                        "base-image": baseImage.value,
                                        reset: resetInprogress.value,
                                        loading: _unref(isLoading),
                                        "section-reset": sectionReset.value,
                                        "disable-action": showConfirmation.value,
                                        onApplied: appliedChanges,
                                        onReset: resetChanges,
                                        onChangeActiveTool: setActiveTool,
                                        onUpdate: setUpdate
                                    }, null, 8, ["stage", "group", "base-image", "reset", "loading", "section-reset", "disable-action"]),
                                    _createElementVNode("div", _hoisted_2, [
                                        _createElementVNode("div", _hoisted_3, [
                                            (showLoader.value)
                                                ? (_openBlock(), _createBlock(_unref(UISpin), {
                                                    key: 0,
                                                    size: "large",
                                                    class: "absolute left-1/2 top-1/2 z-20"
                                                }))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", {
                                                class: _normalizeClass([showLoader.value ? 'hidden w-0 h-0' : 'w-full h-full', "items-center justify-center flex flex-col bg-gray-100"])
                                            }, _hoisted_5, 2)
                                        ], 512),
                                        _createVNode(CropSubTool, {
                                            "base-image": baseImage.value,
                                            stage: _unref(stage),
                                            "selected-option": selectedOption.value,
                                            "adjustment-changes": adjustmentChanges.value,
                                            "filter-changes": filterChanges.value,
                                            "crop-changes": cropChanges.value,
                                            "reset-all": resetInprogress.value,
                                            "disable-action": showConfirmation.value,
                                            onApply: appliedChanges,
                                            onReset: resetChanges
                                        }, null, 8, ["base-image", "stage", "selected-option", "adjustment-changes", "filter-changes", "crop-changes", "reset-all", "disable-action"])
                                    ]),
                                    _createVNode(_unref(ConfirmationModal), {
                                        showModal: showConfirmation.value,
                                        onContinueEditing: continueEditing,
                                        onDiscard: close
                                    }, null, 8, ["showModal"])
                                ])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["show"])
            ]));
        };
    }
});
